import { Route, Routes } from 'react-router-dom'
import { LoginCallback } from '@okta/okta-react'
import Dashboard from './pages/Dashboard'
import ScanDetail from './pages/ScanDetail'
import Login from './pages/Login'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/login/callback" element={<LoginCallback />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/scans/:scanId" element={<ScanDetail />} />
        </Route>
      </Route>
    </Routes>
  )
}

export default App
